// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectChip_container__2K57r","chip":"SelectChip_chip__3nLR-","span":"SelectChip_span__ldWyO","visible":"SelectChip_visible__sRKbs","option":"SelectChip_option__17QPH"};